import React, { useState } from "react"
import Img from "gatsby-image"
import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import { Link } from "gatsby"
import { useTranslation } from 'gatsby-plugin-react-i18next'

import font from "../../fonts/fonts.module.scss"
import styled from "styled-components"
import { device } from "../device"

import { Button } from "../buttons"

const VinhosBanner = ({ data, vinho, changeFilter, types, link, full, opacity }) => {
  const {t} = useTranslation()
  const breakpoints = useBreakpoint()

  const [filter, setFilter] = useState(0);

  function change(i, type) {
    if(i !== filter){
      changeFilter(type);
      setFilter(i);
    }
    else{
      changeFilter("none");
      setFilter(0);
    }
  }
  
  return(
    <StyledVinhos opacity={opacity}>
      <Img fluid={data.banner.childImageSharp.fluid} style={{ width: `100%` }} imgStyle={{ objectFit: "cover" }}/>
      {!breakpoints.mobile &&
        <>
          {changeFilter && 
            <div className="selector">
              {types.vb && <Button filterSelection className={filter===1 ? "selec filterBtn" : "filterBtn"} onClick={() => change(1, "Vinho Branco")}><h4 className={font.nSR}>{t('sidebar:vinhos.tipos.branco')}</h4></Button>}
              {types.vt && <Button filterSelection className={filter===2 ? "selec filterBtn" : "filterBtn"} onClick={() => change(2, "Vinho Tinto")}><h4 className={font.nSR}>{t('sidebar:vinhos.tipos.tinto')}</h4></Button>}
              {types.vr && <Button filterSelection className={filter===3 ? "selec filterBtn" : "filterBtn"} onClick={() => change(3, "Vinho Rosé")}><h4 className={font.nSR}>{t('sidebar:vinhos.tipos.rose')}</h4></Button>}
              {types.vl && <Button filterSelection className={filter===4 ? "selec filterBtn" : "filterBtn"} onClick={() => change(4, "Vinho Licoroso")}><h4 className={font.nSR}>{t('sidebar:vinhos.tipos.licor')}</h4></Button>}
              {types.es && <Button filterSelection className={filter===5 ? "selec filterBtn" : "filterBtn"} onClick={() => change(5, "Espumante")}><h4 className={font.nSR}>{t('sidebar:vinhos.tipos.espumante')}</h4></Button>}
              {types.vp && <Button filterSelection className={filter===6 ? "selec filterBtn" : "filterBtn"} onClick={() => change(6, "Vinho do Porto")}><h4 className={font.nSR}>{t('sidebar:vinhos.tipos.porto')}</h4></Button>}
            </div>
          }
        </>
      }
      <div className="bannerContent">
        <h2 className={font.nSR + " bannerTitle"}>  
          {(() => {
            switch (vinho) {
              case 'bairrada':
                return t('vinhos:banners.docs.bairrada.title')
              case 'dao':
                return t('vinhos:banners.docs.dao.title')
              case 'douro':
                return t('vinhos:banners.docs.douro.title')
              case 'setubal':
                return t('vinhos:banners.docs.setubal.title')
              case 'palmela':
                return t('vinhos:banners.docs.palmela.title')
              case 'porto':
                return t('vinhos:banners.docs.porto.title')
              case 'tejo':
                return t('vinhos:banners.docs.tejo.title')
              case 'verde':
                return t('vinhos:banners.docs.verde.title')
              case 'lua-cheia':
                return t('vinhos:banners.docs.luacheia.title')
              case 'azul-portugal':
                return t('vinhos:banners.docs.azulportugal.title')
              case 'reg-alentejo':
                return t('vinhos:banners.regionais.alentejo.title')
              case 'reg-minho':
                return t('vinhos:banners.regionais.minho.title')
              case 'reg-setubal':
                return t('vinhos:banners.regionais.setubal.title')
              case 'reg-tejo':
                return t('vinhos:banners.regionais.tejo.title')
              case 'mesa':
                return t('vinhos:banners.regionais.mesa.title')
              default:
                return '';
            }
          })()}
        </h2>
        {!breakpoints.mobile && 
          <p className={font.nSR + " bannerTxt"}>
            {(() => {
              switch (vinho) {
                case 'bairrada':
                  return t('vinhos:banners.docs.bairrada.text')
                case 'dao':
                  return t('vinhos:banners.docs.dao.text')
                case 'douro':
                  return t('vinhos:banners.docs.douro.text')
                case 'setubal':
                  return t('vinhos:banners.docs.setubal.text')
                case 'palmela':
                  return t('vinhos:banners.docs.palmela.text')
                case 'porto':
                  return t('vinhos:banners.docs.porto.text')
                case 'tejo':
                  return t('vinhos:banners.docs.tejo.text')
                case 'verde':
                  return t('vinhos:banners.docs.verde.text')
                case 'lua-cheia':
                  return t('vinhos:banners.docs.luacheia.text')
                case 'azul-portugal':
                  return t('vinhos:banners.docs.azulportugal.text')
                case 'reg-alentejo':
                  return t('vinhos:banners.regionais.alentejo.text')
                case 'reg-minho':
                  return t('vinhos:banners.regionais.minho.text')
                case 'reg-setubal':
                  return t('vinhos:banners.regionais.setubal.text')
                case 'reg-tejo':
                  return t('vinhos:banners.regionais.tejo.text')
                case 'mesa':
                  return t('vinhos:banners.regionais.mesa.text')
                default:
                  return '';
              }
            })()}
          </p>
        }
        {(breakpoints.mobile && !full) &&
          <Link 
            to={
              (() => {
                switch (vinho) {
                  case 'bairrada':
                    return t('vinhos:verMais.docs.bairradaLnk')
                  case 'dao':
                    return t('vinhos:verMais.docs.daoLnk')
                  case 'douro':
                    return t('vinhos:verMais.docs.douroLnk')
                  case 'setubal':
                    return t('vinhos:verMais.docs.setubalLnk')
                  case 'palmela':
                    return t('vinhos:verMais.docs.palmelaLnk')
                  case 'porto':
                    return t('vinhos:verMais.docs.portoLnk')
                  case 'tejo':
                    return t('vinhos:verMais.docs.tejoLnk')
                  case 'verde':
                    return t('vinhos:verMais.docs.verdeLnk')
                  default:
                    return '';
                }
              })()
            } 
            className="verMais-mobile">
              <Button className='ver-todos'><h4 className={font.nSR}>{t('vinhos:banners.vertodos')}</h4></Button>
          </Link>
        }
      </div>
    </StyledVinhos>
  )
}

export default VinhosBanner

const StyledVinhos = styled.div`
  position: relative;

  .gatsby-image-wrapper{
    max-height:550px;
    opacity: ${props => props.opacity ? '0.3' : '1'}
  }

  .bannerContent{
    position: absolute;
    bottom: 5vw;
    left: 5vw;
    width: 80%;
    color: #fff;
    max-width:700px;

    @media ${device.desktopM}{
      width: 45%;
    }

    .bannerTitle{
      font-size:30px;
      margin-bottom:15px;

      @media ${device.tabletM}{
        font-size:46px;
      }
    }
  }

  .selector{
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-gap: 10px;
    position: absolute;
    top: 25px;
    left: 25px;

    .filterBtn{
      border-radius:0;
    }
  }

  .verMais-mobile{
    margin-top:10px;
  }

  .ver-todos{
    border:1px solid #fff;
    border-radius:0;
    padding: 5px 15px;
    color:#fff;
    width:fit-content;

    &.selec{
      background-color:#fff;
      color:#3e3028;
    }

    h4{
      font-size:15px;
      color:#fff;
    }
  }
`